import * as React from 'react';

class PhoneSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon phone-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          xmlns="http://www.w3.org/2000/svg"
          d="M19.575 14.625L17.5 12.5584C17.3652 12.4226 17.2049 12.3148 17.0283 12.2412C16.8516 12.1677 16.6622 12.1298 16.4708 12.1298C16.2795 12.1298 16.0901 12.1677 15.9134 12.2412C15.7368 12.3148 15.5765 12.4226 15.4417 12.5584L13.9583 14.0417C13.5917 13.8917 12.8667 13.5667 12.05 13.125C11.1233 12.652 10.2654 12.0548 9.50001 11.35C8.69732 10.4692 8.02392 9.47874 7.50001 8.40837C7.24168 7.90837 7.03334 7.45837 6.88334 7.13337L6.76668 6.86671L8.25001 5.38337C8.38582 5.24859 8.4936 5.08826 8.56716 4.91163C8.64071 4.73499 8.67858 4.54555 8.67858 4.35421C8.67858 4.16287 8.64071 3.97342 8.56716 3.79679C8.4936 3.62016 8.38582 3.45983 8.25001 3.32504L6.18334 1.25837C5.91144 0.986634 5.54276 0.833984 5.15834 0.833984C4.77393 0.833984 4.40525 0.986634 4.13334 1.25837L1.10001 4.29171C0.903425 4.52357 0.802162 4.8214 0.816677 5.12504C0.858395 5.82421 1.00736 6.51281 1.25834 7.16671C2.27013 10.0135 3.83327 12.6329 5.85834 14.875C7.37506 16.2802 9.09075 17.4539 10.95 18.3584C11.8069 18.8 12.6922 19.1842 13.6 19.5084C14.2562 19.7628 14.9476 19.9146 15.65 19.9584C15.9538 19.9737 16.2519 19.8724 16.4833 19.675L19.575 16.6667C19.8468 16.3948 19.9994 16.0261 19.9994 15.6417C19.9994 15.2573 19.8468 14.8886 19.575 14.6167V14.625Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default PhoneSvg;
